import React from "react";

// Accessible on/off switch (blue when on).
export default function Toggle({ checked, onChange, label, t, disabled }) {
  return (
    <button type="button" role="switch" aria-checked={!!checked} aria-label={label} data-testid={t} disabled={disabled}
      onClick={() => onChange(!checked)}
      className={`relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors disabled:opacity-50 ${checked ? "bg-blue-600" : "bg-slate-300"}`}>
      <span className={`inline-block h-4 w-4 rounded-full bg-white shadow transition-transform ${checked ? "translate-x-[18px]" : "translate-x-0.5"}`} />
    </button>
  );
}
